// extracted by mini-css-extract-plugin
module.exports = {"inlineValidationWarning":"_36920f9"};